import {Component, Inject, Optional} from '@angular/core';
import {DocumentoModel} from "../../../aplicacao/models/nova-parceria/nova-cotacao.model";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {AlertaService} from "../../../bibliotecaPjus/services/alerta.service";
@Component({
  selector: 'app-upload-documento-mobile',
  templateUrl: './upload-documento-mobile.component.html',
  styleUrls: ['./upload-documento-mobile.component.scss']
})
export class UploadDocumentoMobileComponent {
  selectedFiles;
  propostaId;
  nomeArquivo;
  listaDocumentos = [];
  validarFormulario = true;
  msgErroDocumento;
  model = new DocumentoModel();
  constructor(
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public dataBotton,
    private bottomSheetRef: MatBottomSheetRef<UploadDocumentoMobileComponent>,
    protected alertaService: AlertaService
  ) {
    this.listaDocumentos = this.dataBotton;
  }


  ngOnInit() { }

  fechar(): void {
    this.bottomSheetRef.dismiss(false);
  }
  enviar(): void {
    const form = this.model.asForm;
    this.validarFormulario = true;
    if(form.valid) {
      this.validarFormulario = true;
      this.bottomSheetRef.dismiss(this.model);
    } else {
      this.validarFormulario = false;
    }
  }


  uploadArquivo(event): void {
    this.selectedFiles = event;
    if (this.selectedFiles.target.files && this.selectedFiles.target.files[0]) {
      const file = this.selectedFiles.target.files[0];
      const maxFileSize = 200 * 1024 * 1024; // 200MB in bytes
      this.nomeArquivo = file.name;

      if (file.size > maxFileSize) { // Strictly allow files up to 200MB
        this.msgErroDocumento = 'O arquivo selecionado excede o limite de 200 MB. Por favor, escolha um arquivo menor';
        this.model.form.controls.base64.setValue(null);
        this.model.form.controls.extensao.setValue(null);
        return;
      }

      const allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.msgErroDocumento = 'O tipo do arquivo selecionado está inválido';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const r = e.target.result;
        if (typeof e.target.result === 'string') {
          const base64String = e.target.result.split(',').pop();
          this.model.form.controls.base64.setValue(base64String);
          this.model.form.controls.extensao.setValue(file.name.split('.').pop().toLowerCase());
        }
      };
      reader.readAsDataURL(file);
    }
  }
}
